import { ApiAction, ApiState, initialApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Preorder from '../../models/Preorder';

export interface PreorderDataState extends ApiState {
  preorder?: Preorder
}

export const emptyPreorder: Preorder = {
  id: null,
  dateCreated: '',
  clientId: 0,
  personId: 0,
  prepaymentId: '',
  priceListId: 0,
  dateUpdated: '',
  remarks: '',
  status: 'A'
}


const preorderData = (state: PreorderDataState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    case 'PREORDER_CLEAR':
      return { ...state, preorder: emptyPreorder }
    default:
      return requestReducer<PreorderDataState>('PREORDER_DATA')(state, action)
  }
}

export default preorderData